/* Doom Scroller storefront behaviour */
(function () {
  'use strict';
  var DS = window.DS || { products: {}, sym: '$', cur: 'USD' };
  var P = DS.products;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cart = null;
  var lastFocus = null;

  function fmt(cents) {
    var n = cents / 100;
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return DS.sym + (whole ? String(Math.round(n)) : n.toFixed(2));
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function say(msg) { var l = $('[data-live]'); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = msg; }, 30); } }
  function handleOf(item) { return item.handle; }

  function api(url, body) {
    var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    return fetch(url, opt).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function load() { return api('/cart.js').then(function (c) { cart = c; render(); return c; }); }

  /* ---------- cart drawer ---------- */
  function openCart() {
    var d = $('#ds-cart'); if (!d) { location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    d.hidden = false; $('.scrim').hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var b = $('[data-close-cart].icon-btn', d); if (b) b.focus();
    var sb = $('[data-sticky]'); if (sb) sb.hidden = true;
  }
  function closeCart() {
    var d = $('#ds-cart'); if (!d) return;
    d.hidden = true; $('.scrim').hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function add(handle) {
    var p = P[handle];
    if (!p) return;
    var inCart = cart && cart.items.some(function (i) { return handleOf(i) === handle; });
    if (inCart) { openCart(); say(p.name + ' is already in your cart.'); return; }
    var rel = [];
    if (p.kind === 'bundle') rel = p.contains;
    api('/cart/add.js', { items: [{ id: p.id, quantity: 1 }] })
      .then(load)
      .then(function () { openCart(); say(p.name + ' added to your cart.'); })
      .catch(function (e) { say((e && e.description) || 'That did not work. Try again.'); });
  }

  function setLines(updates) {
    return api('/cart/update.js', { updates: updates }).then(load);
  }
  function removeKey(key) { var u = {}; u[key] = 0; return setLines(u); }

  function swapTo(handle) {
    var b = P[handle]; var u = {};
    cart.items.forEach(function (i) {
      var h = handleOf(i);
      if (b.contains.indexOf(h) > -1) u[i.key] = 0;
      if (handle === 'the-entire-library' && P[h] && P[h].kind === 'bundle') u[i.key] = 0;
    });
    var have = cart.items.some(function (i) { return handleOf(i) === handle; });
    var p = Object.keys(u).length ? setLines(u) : Promise.resolve();
    return p.then(function () { return have ? load() : api('/cart/add.js', { items: [{ id: b.id, quantity: 1 }] }).then(load); })
      .then(function () { say('Swapped to ' + b.name + '.'); });
  }

  function sepOf(h) { return P[h].contains.reduce(function (a, c) { return a + (P[c] ? P[c].price : 0); }, 0); }
  function pctOf(h) { var s = sepOf(h); return s ? Math.round((s - P[h].price) / s * 100) : 0; }

  function render() {
    if (!cart) return;
    var count = cart.item_count;
    $$('[data-badge]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    $$('[data-open-cart]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items')); });
    $$('#ds-cart [data-count]').forEach(function (c) { c.textContent = count; });
    var lines = $('[data-lines]'); if (!lines) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="empty"><p class="disp h3" style="color: #F3F1EA">Empty. Like your drafts folder.</p><a class="btn btn-acc" href="/collections/all">Shop the vault</a></div>';
    } else {
      lines.innerHTML = cart.items.map(function (i) {
        var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        return '<div class="line"><div class="th has-cover">' + (img ? '<img class="cover" src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="">' : '') + '</div>' +
          '<div><a class="line-name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a><div class="mono muted" style="margin-top: 2px">' + fmt(i.final_price) + ' each</div></div>' +
          '<div class="line-right"><span class="mono" style="font-weight: 700">' + fmt(i.final_line_price) + '</span><button class="rm" type="button" data-rm="' + esc(i.key) + '">Remove<span class="sr"> ' + esc(i.product_title) + '</span></button></div></div>';
      }).join('');
    }
    $('[data-totals]').hidden = !cart.items.length;
    $('[data-sub]').textContent = fmt(cart.items_subtotal_price);
    $('[data-total]').textContent = fmt(cart.total_price);

    // bundle tips
    var inCart = {}; cart.items.forEach(function (i) { inCart[handleOf(i)] = true; });
    var lib = 'the-entire-library';
    var cats = ['the-hook-bundle', 'the-format-bundle', 'the-visual-layout-bundle'].filter(function (h) { return P[h]; });
    var minPct = Math.min.apply(null, cats.map(pctOf));
    var tip = { msg: 'Bundles save ' + minPct + '%. The Entire Library saves ' + (P[lib] ? pctOf(lib) : 0) + '%.' };
    var sub = cart.items_subtotal_price;
    if (P[lib] && !inCart[lib] && sub >= P[lib].price) {
      tip = { msg: 'You’re about to pay more than the Entire Library. Get all 10 packs for ' + fmt(P[lib].price) + ' instead.', label: 'Swap to the Entire Library', go: lib };
    } else if (!inCart[lib]) {
      cats.forEach(function (b) {
        if (tip.go || inCart[b]) return;
        var have = P[b].contains.filter(function (h) { return inCart[h]; });
        if (have.length >= 2) {
          tip = { msg: 'You’ve got ' + have.length + ' of the ' + P[b].contains.length + ' in ' + P[b].name + '. Get all ' + P[b].contains.length + ' for ' + fmt(P[b].price) + ' and save ' + fmt(sepOf(b) - P[b].price) + '.', label: 'Swap to the bundle', go: b };
        }
      });
    }
    $('[data-tip-msg]').textContent = tip.msg;
    var go = $('[data-tip-go]');
    go.hidden = !tip.go; go.textContent = tip.label || ''; go.dataset.swap = tip.go || '';
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    var a = t.closest('[data-add]');
    if (a) { e.preventDefault(); add(a.getAttribute('data-add')); return; }
    if (t.closest('[data-open-cart]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-close-cart]')) { e.preventDefault(); closeCart(); return; }
    var rm = t.closest('[data-rm]');
    if (rm) { removeKey(rm.getAttribute('data-rm')).then(function () { say('Removed from your cart.'); }); return; }
    var sw = t.closest('[data-tip-go]');
    if (sw && sw.dataset.swap) { swapTo(sw.dataset.swap); return; }
    if (t.closest('[data-burger]')) {
      var m = $('#ds-menu'), btn = $('[data-burger]');
      var open = m.hidden; m.hidden = !open; btn.setAttribute('aria-expanded', String(open));
      $('[data-ico-open]').hidden = open; $('[data-ico-close]').hidden = !open;
      return;
    }
    if (t.closest('[data-cookie-prefs]')) {
      if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
      else location.href = '/pages/cookie-policy';
      return;
    }
    var th = t.closest('[data-gallery] .thumb');
    if (th) {
      var g = th.closest('[data-gallery]'), main = $('[data-main]', g);
      main.src = th.getAttribute('data-src'); main.alt = th.getAttribute('data-alt');
      $$('.thumb', g).forEach(function (x) { x.classList.toggle('on', x === th); x.setAttribute('aria-pressed', String(x === th)); });
      return;
    }
    var chip = t.closest('[data-filter]');
    if (chip) { filterShop(chip.getAttribute('data-filter')); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-agree]')) {
      var ok = e.target.checked;
      $('[data-checkout]').hidden = !ok; $('[data-checkout-off]').hidden = ok;
    }
    if (e.target.matches('[data-cur]')) e.target.form.submit();
    if (e.target.id === 'ds-sort') sortShop(e.target.value);
  });

  /* ---------- shop filters ---------- */
  function filterShop(f) {
    var grid = $('[data-grid]'); if (!grid) return;
    var n = 0;
    $$('.pcard', grid).forEach(function (c) { var show = f === 'all' || c.getAttribute('data-cat') === f; c.hidden = !show; if (show) n++; });
    $$('[data-filter]').forEach(function (c) { var on = c.getAttribute('data-filter') === f; c.classList.toggle('on', on); c.setAttribute('aria-pressed', String(on)); });
    var cnt = $('[data-shop] [data-count]'); if (cnt) cnt.textContent = n + (n === 1 ? ' product' : ' products');
  }
  function sortShop(v) {
    var grid = $('[data-grid]'); if (!grid) return;
    var cards = $$('.pcard', grid);
    cards.sort(function (a, b) {
      if (v === 'low') return a.dataset.price - b.dataset.price;
      if (v === 'high') return b.dataset.price - a.dataset.price;
      return a.dataset.i - b.dataset.i;
    }).forEach(function (c) { grid.appendChild(c); });
  }

  /* ---------- videos: play only on screen ---------- */
  function initVideos() {
    var vids = $$('video[data-src]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var start = function (v) {
      if (!v.src) { v.src = v.getAttribute('data-src'); v.muted = true; }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) start(x.target); else if (x.target.src) x.target.pause(); });
    }, { rootMargin: '200px' });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* ---------- sticky buy bar ---------- */
  function initSticky() {
    var row = $('[data-buyrow]'), bar = $('[data-sticky]');
    if (!row || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var e = en[0]; var d = $('#ds-cart');
      bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0 || (d && !d.hidden);
    }).observe(row);
  }

  function init() {
    initVideos(); initSticky();
    var shop = $('[data-shop]'); if (shop) filterShop(shop.getAttribute('data-start') || 'all');
    load().catch(function () {});
    if (/[?&]cart=open/.test(location.search)) openCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
